import { render, staticRenderFns } from "./MigrationsAlert.vue?vue&type=template&id=f1263446&"
import script from "./MigrationsAlert.vue?vue&type=script&lang=js&"
export * from "./MigrationsAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1263446')) {
      api.createRecord('f1263446', component.options)
    } else {
      api.reload('f1263446', component.options)
    }
    module.hot.accept("./MigrationsAlert.vue?vue&type=template&id=f1263446&", function () {
      api.rerender('f1263446', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Migrations/MigrationsAlert.vue"
export default component.exports